<template>
  <div class="tw-bg-[#031b41] tw-rounded-xl sm:tw-block tw-hidden">
    <div class="tw-text-white tw-pb-3 tw-pt-5 tw-px-5 tw-text-left tw-font-semibold tw-text-lg">Game Categories</div>
    <v-divider class="tw-border-white"></v-divider>
    <div>
      <v-list dense nav class="tw-bg-transparent">
        <v-list-item-group v-model="selectedItem" nav mandatory>
          <v-list-item
            :active-class="`${isActive(item) ? 'tw-bg-transparent tw-text-[#e4682d]' : ''}`"
            v-for="(item, i) in items.filter((item) => !item.admin)"
            :value="item.name"
            :key="item.name"
            @click="gotoPage(item.link, item.redirect)"
          >
            <div class="tw-flex tw-items-center tw-space-x-4">
              <div>
                <v-icon v-text="item.icon"></v-icon>
              </div>
              <v-list-item-title class="tw-text-left tw-font-bold" v-text="item.text"></v-list-item-title>
            </div>
          </v-list-item>
          <v-list-item
            v-if="$auth.user && ['super_admin', 'admin'].includes($auth.user.type)"
            :active-class="`${isActive(item) ? 'tw-bg-transparent tw-text-[#e4682d]' : ''}`"
            v-for="(item, i) in items.filter((item) => item.admin)"
            :value="item.name"
            :key="item.name"
            @click="gotoPage(item.link, item.redirect)"
          >
            <div class="tw-flex tw-items-center tw-space-x-4">
              <div>
                <v-icon v-text="item.icon"></v-icon>
              </div>
              <v-list-item-title class="tw-text-left tw-font-bold" v-text="item.text"></v-list-item-title>
            </div>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedItem: "",
    items: [
      {
        icon: "mdi-home",
        text: "Home",
        link: "/",
        name: "Home",
      },
      {
        icon: "mdi-slot-machine",
        text: "Slots",
        link: "/slots",
        name: "Slots",
      },
      {
        icon: "mdi-dice-multiple",
        text: "Live Casino",
        link: "/live-casino",
        name: "LiveCasino",
      },

      {
        icon: "mdi-heart",
        text: "Favorites",
        link: "/favorites",
        name: "Favorites",
      },
      {
        icon: "mdi-history",
        text: "Recently Played",
        link: "/recent-games",
        name: "RecentGames",
      },
      {
        icon: "mdi-gamepad-variant-outline",
        text: "Community Betting",
        link: "/",
        name: "CommunityBetting",
        redirect: true,
      },
      {
        icon: "mdi-shield-crown",
        text: "Administrator",
        name: "Admin",
        link: "/admin/casino-games",
        admin: true,
      },
    ],
  }),
  mounted() {
    switch (this.$route.name) {
      case "Home":
        this.selectedItem = "Home";
        break;
      case "Slots":
        this.selectedItem = "Slots";
        break;
      case "LiveCasino":
        this.selectedItem = "LiveCasino";
        break;
      case "Favorites":
        this.selectedItem = "Favorites";
        break;
      case "RecentGames":
        this.selectedItem = "RecentGames";
        break;
      case "AdminGames":
      case "AdminCasinoGames":
        this.selectedItem = "Admin";
        break;
      default:
        this.selectedItem = "Home";
    }
  },

  methods: {
    isActive(item) {
      if (item.name == "Admin") {
        return true;
      }
      return this.$route.name === item.name;
    },
    gotoPage(link, redirect) {
      if (redirect) {
        const url =
          process.env.VUE_APP_SERVER_ENV == "prod"
            ? process.env.VUE_APP_2EZ_URL || "https://2ez.bet"
            : "http://localhost:8000";
        window.open(url);
      } else {
        this.$router.push({ path: link });
      }
    },
  },
};
</script>

<style scoped>
.v-list-item--link:before {
  opacity: 0;
}
</style>
